import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import {
  UiZoneWidgetAttributeConfig,
  ValidationRuleTypes,
  ValidationRules,
  WidgetPropertiesType,
} from '@finxone-platform/shared/sys-config-types';

export function getSpecificWidgetPropertyStyle(
  widgetConfiguration: UiZoneWidgetAttributeConfig,
  propertyName: Array<string>,
) {
  let widgetProperty: { textContent: string; color: string } = {
    textContent: '',
    color: '',
  };
  propertyName.forEach((cssPropertyName) => {
    switch (cssPropertyName) {
      case WidgetPropertiesType.HEADER_CONFIG:
        widgetProperty = {
          ...widgetProperty,
          ...getHeaderColor(widgetConfiguration),
        };
        break;

      case WidgetPropertiesType.SUBHEADER_CONFIG:
        widgetProperty = {
          ...widgetProperty,
          ...getSubHeaderColor(widgetConfiguration),
        };
        break;
      case WidgetPropertiesType.TABLE_HEADER_CONFIG:
        widgetProperty = {
          ...widgetProperty,
          ...getTableHeaderStyleConfig(widgetConfiguration),
        };
        break;
      case WidgetPropertiesType.TABLE_GRID_SETTING:
        widgetProperty = {
          ...widgetProperty,
          ...getTableGridSetting(widgetConfiguration),
        };
        break;
      case WidgetPropertiesType.TABLE_ROW_SETTING:
        widgetProperty = {
          ...widgetProperty,
          ...getTableRowSetting(widgetConfiguration),
        };
        break;
      default:
        break;
    }
  });

  return widgetProperty;
}

export function getHeaderColor(widgetConfiguration: UiZoneWidgetAttributeConfig) {
  return {
    color: `${widgetConfiguration?.widgetProperties?.headerConfig?.headerColor}`,
    'font-size': `${widgetConfiguration?.widgetProperties?.headerConfig?.headerFontSize}${
      widgetConfiguration?.widgetProperties?.headerConfig?.headerFontUnit ?? 'px'
    }`,
    'font-family': `${widgetConfiguration?.widgetProperties?.headerConfig?.headerTextFont}`,
  };
}
export function getSubHeaderColor(widgetConfiguration: UiZoneWidgetAttributeConfig) {
  return {
    color: `${widgetConfiguration?.widgetProperties?.subHeaderConfig?.subheaderColor}`,
    'font-size': `${widgetConfiguration?.widgetProperties?.subHeaderConfig?.subHeaderFontSize}${
      widgetConfiguration?.widgetProperties?.subHeaderConfig?.subHeaderFontUnit ?? 'px'
    }`,
    'font-family': `${widgetConfiguration?.widgetProperties?.subHeaderConfig?.subHeaderTextFont}`,
  };
}

export function getTableRowSetting(widgetConfiguration: UiZoneWidgetAttributeConfig) {
  return {
    'background-color': `${widgetConfiguration?.['rowSettings']?.rowBgColor}`,
  };
}

export function getValidationRules(validations: ValidationRules[]) {
  const widgetValidation: ((control: AbstractControl<any, any>) => ValidationErrors | null)[] = [];

  validations.forEach((validation) => {
    switch (validation.type) {
      case ValidationRuleTypes.REQUIRED:
        if (validation?.value == 'true') {
          widgetValidation.push(Validators.required);
        }
        break;
      case ValidationRuleTypes.MAXLENGTH:
        widgetValidation.push(Validators.maxLength(parseInt(validation.value)));
        break;
      default:
        break;
    }
  });
  return widgetValidation;
}

export function getTableHeaderStyleConfig(widgetConfiguration: UiZoneWidgetAttributeConfig) {
  return {
    color: `${widgetConfiguration?.['tableHeaderSetting']?.css_config?.tableHeaderTextColor}`,
    'background-color': `${widgetConfiguration?.['tableHeaderSetting']?.css_config?.tableHeaderBackgroundColor}`,
    'font-family': `${widgetConfiguration?.['tableHeaderSetting']?.css_config?.tableHeaderFontFamily}`,
    'font-size': `${widgetConfiguration?.['tableHeaderSetting']?.css_config?.tableHeaderFontSize}${
      widgetConfiguration?.['tableHeaderSetting']?.css_config?.tableHeaderFontUnit ?? 'px'
    }`,
  };
}

export function getTableGridSetting(widgetConfiguration: UiZoneWidgetAttributeConfig) {
  return {
    border: `${widgetConfiguration?.['tableGridSetting']?.gridLinesColor}`,
  };
}
